export default __webpack_public_path__ + "static/media/books2-afterB.986a29b4.jpg";